import { createContext } from "react";

const initialValue = {
  hospitals: [],
  user: {
    name: "",
    role: "",
    email: "",
    auth_token: "",
  },
};

export const district_Context = createContext(initialValue);

district_Context.displayName = "District Context";
